import { Outlet } from "react-router-dom";

const IhioPrescriptionBill = () => {

    return <Outlet />
}

export default IhioPrescriptionBill;